document.addEventListener('DOMContentLoaded', function () {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    if (typeof Lenis === 'undefined') return;

    const lenis = new Lenis({
        duration: 1.2,
        smooth: true,
        smoothTouch: false,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
});